import Vue from 'vue'
import Vuex from 'vuex'
import moduleWL from './wl/modulesWL.js'
import moduleSD from './sd/modulesSD.js'
import moduleSYZ from './syz/moduleSYZ'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 触发条件列表
    triggerConditionList:[{
      id: 0,
      value:'全部'
    },{
        id: 1,
        value:'大于A'
    },{
        id: 2,
        value:'小于A'
    },{
        id: 3,
        value:'大于A且小于B'
    },{
        id: 4,
        value: '大于A或小于B'
    }],
     // 状态开关
    statusList:[{
      id: 0,
      label:'全部'
    },{
      id: 1,
      label:'开启状态'
    },{
      id: 2,
      label:'关闭状态'
    }],
    // 推送机制
    mechanismList: [{
      id: 0,
      label: '全部'
    },{
        id: 1,
        label: '仅发送一次'
    },{
        id: 2,
        label: '间隔一定时间发送'
    }],
    isCompare: false, // 首页是否打开数据对比按钮
    compareData:[], // 首页选中的对比的设备数据
  },
  mutations: {
    updateState(state, payload) {
      state[payload.key] = payload.val
    },
    changeStatus(state,data) {
      state.isCompare = data
    },
    changeData(state,data) {
      state.compareData = data
    },
  },
  actions: {
    getStatus(store,data) {
      store.commit('changeStatus',data)
    },
    getCompareData(store,data) {
      store.commit('changeData',data)
    }
  },
  modules: {
    moduleWL,
    moduleSD,
		moduleSYZ
  }
})
